
<template>
  <div>
    <!--导航-->
    <!--顶部 开始-->
    <div id="top_main">
      <div id="top">
        <div id="top_1">
          <img :src='info.logoUrl' title='棕榈产业智慧管理' alt='棕榈产业智慧管理' >
        </div>
        <div id="top_2">
          <div id="lan_def"
               @mouseenter="showLanguageDropdown = true"
               @mouseleave="showLanguageDropdown = false">

            <div id="lan_defult">   <font-awesome-icon :icon="['fas', 'language']" />&nbsp;&nbsp;
              {{ langItems.find(item => item.type === currentLanguage)?.title || '中文简体' }}                  </div>
            <ul  id="lan_sel"
                 :class="{ 'show': showLanguageDropdown }"
                 :style="{ visibility: showLanguageDropdown ? 'visible' : 'hidden', opacity: showLanguageDropdown ? '1' : '0' }">
              <li v-for="(item ,index) in langItems" :key="index" @click="changeLanguage(item)">
                <font-awesome-icon :icon="['fas', 'circle']" v-if="currentLanguage === item.type" />
                <font-awesome-icon :icon="['far', 'circle']" v-else />&nbsp;&nbsp;
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </div>
          <div style="margin-left: 20px" class="pointer" @click="goLogin">{{t('登录')}}</div>
        </div>
      </div>
    </div>
    <!--顶部 结束-->
    <!--Logo 开始-->
    <div id="logo_main">
      <div id="logo">
        <!--导航 开始-->
        <div class="navigation">
          <ul class="navigationlist" style="display: flex;height: 70px">
            <li v-for="(item, index) in navItems" :key="index" v-show="item.status == 0">
              <div class="pointer  " :class="{ 'current': index == props.isCurrent }"  @click="goPage(item.href ,index)"
              >
                {{ item.title }}
              </div>
              <ul v-if="item.subItems && item.subItems.length" class="subnavigationlist">
                <li v-for="(subItem, subIndex) in item.subItems" :key="subIndex"  @click="goPage1(subItem )">
                  <!-- <router-link :to="subItem.href" >{{  }}</router-link> -->
                  <a href="javascript:;">{{ subItem.title }} </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!--导航 结束-->
      </div>
    </div>
    <!--Logo 结束-->
  </div>
</template>

<script setup>
import { defineProps, ref, computed, onMounted,watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import router from '@/router';
import { getSimpleListApi ,getInfoTypeApi ,getModuleListApi} from '@/api/index'
const { locale, t } = useI18n();
const info =ref({})
const store = useStore();

const props = defineProps({
  isCurrent: {
    type: Number,
    default: 0
  }
});
function goLogin() {
  window.open('https://hp.20251127.com/web/', '_blank');
}
// 控制语言下拉菜单显示状态
const showLanguageDropdown = ref(false);
const currentLanguage = computed(() => locale.value);

// 使用全局状态中的菜单数据
const newsSubItems = computed(() => store.getters.getMenuData.newsSubItems);
const productSubItems = computed(() => store.getters.getMenuData.productSubItems);
const apiDataCache = ref([])
// 切换语言函数
const changeLanguage = (lang) => {
  locale.value = lang;
  // 将语言设置保存到本地存储
  localStorage.setItem('locale', lang.type);
  localStorage.setItem('languageType', lang.lat);
  // 清除菜单数据以在语言变化后重新加载
  store.commit('CLEAR_MENU_DATA');
  // 刷新页面以确保所有内容都更新
  window.location.reload();
};
async function getInfoType() {
  let res = await getInfoTypeApi();
  info.value = res.data;
}
async function getModuleLis() {
  let res = await getModuleListApi();
  // 缓存接口数据
  apiDataCache.value = res.data;
  updateNavItems(res.data);
}
const langItems = [
  { title: t('中文简体'), type: 'zh-CN', lat: 1 },
  { title: t('中文繁体'), type: 'zh-TW', lat: 2 },
  { title: t('English'), type: 'en', lat: 5 },
  { title: t('Bahasa Malaysia'), type: 'ms', lat: 4 },
  { title: t('Bahasa indonesia'), type: 'id', lat: 3 },
  // { title: t('Deutsch, glaube ich.'), type: 'de' },
  // { title: t('العربية'), type: 'ar' },
  // { title: t('español'), type: 'es' },
  // { title: t('En français'), type: 'fr'  },
  // { title: t('Testo italiano'), type: 'it' },
  // { title: t('日本 ご 語 です '), type: 'ja' },
  // { title: t('한글'), type: 'ko' },
  // { title: t('nederlands'), type: 'nl' },
  // { title: t('Em português'), type: 'pt' },
  // { title: t('русск'), type: 'ru' },
  // { title: t('ภาษาไทย'), type: 'th' },
  // { title: t('Việt nam'), type: 'vi' }
];
// 更新导航数据的函数
const updateNavItems = ( ) => {
  const baseNavItems = [
    { title: t('首页'), href: '/' ,value: '1'},
    { title: t('发展历史'), href: '/HistoryComponent' ,value: '2'},
    { title: t('资质荣誉'), href: '/qualificationsHonors' ,value: '3'},
    { title: t('宣传视频'), href: '/promotionalVideo' ,value: '4'},
    {
      title: t('新闻资讯'),
      href: '/newsConsultation',
      value: '5',
    },
    {
      title: t('产品展示'),
      href: '/productDisplay',
      value: '6',
    },
    { title: t('客户案例'), href: '/customerCase' ,value: '7'},
    { title: t('下载中心'), href: '/DownloadMessage' ,value: '8'},
    { title: t('联系我们'), href: '/contactUs' ,value: '9'},
    { title: t('在线留言'), href: '/OnlineCenter' ,value: '10'}
  ];
  // 为每个导航项添加对应的 status 和 subItems
  navItemsData.value = baseNavItems.map(item => {
    const matchingItem = apiDataCache.value.find(dataItem => dataItem.value === item.value);
    const result = {
      ...item,
      status: matchingItem ? matchingItem.status : 0
    };

    // 特殊处理有子菜单的项
    if (item.value === '5') {
      result.subItems = newsSubItems.value;
    } else if (item.value === '6') {
      result.subItems = productSubItems.value;
    }
    return result;
  });

  store.commit('SET_NAV_ITEMS', navItemsData.value);
};

const navItemsData = ref([]);
// const navItems = computed(() => [
//   { title: t('首页'), href: '/' ,value: '1',},
//   { title: t('发展历史'), href: '/HistoryComponent' ,value: '2',},
//   { title: t('资质荣誉'), href: '/qualificationsHonors' ,value: '3',},
//   { title: t('宣传视频'), href: '/promotionalVideo' ,value: '4',},
//   {
//     title: t('新闻资讯'),
//     href: '/newsConsultation',
//     subItems: newsSubItems.value,
//     value: '5',
//   },
//   {
//     title: t('产品展示'),
//     href: '/productDisplay',
//     subItems: productSubItems.value,
//     value: '6',
//   },
//   { title: t('客户案例'), href: '/customerCase' ,value: '7',},
//   { title: t('下载中心'), href: '/DownloadMessage' ,value: '8',},
//   { title: t('联系我们'), href: '/contactUs' ,value: '9',},
//   { title: t('在线留言'), href: '/OnlineCenter' ,value: '10',}
// ])
const navItems = computed(() => navItemsData.value)
const goPage = (href ) => {

  router.push(href);
};
const goPage1 = (subItem) => {
  router.push(subItem.href);
};
getModuleLis()
getInfoType();
// 监听子菜单数据变化，确保 subItems 正确更新
watch([newsSubItems, productSubItems], () => {
  if (apiDataCache.value.length > 0) {
    updateNavItems();
  }
}, { deep: true });
// 在组件挂载时加载菜单数据
onMounted(async () => {
  try {
    await store.dispatch('loadMenuData', { getSimpleListApi });
  } catch (error) {
    console.error('Failed to load menu data:', error);
  }
});
</script>

<style scoped lang="scss">
/* 导航 */
#navigation_main {
  background: #ff7e46;
}
#top_1 { 
  img {
    margin-top: 10px;
    width: 70px;
    height: 70px;
  }
}
// 语言选择下拉菜单样式
#lan_def {
  position: relative;
  cursor: pointer;
  
  #lan_sel {
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    z-index: 1000;
    overflow: hidden;
    transition: visibility 0.28s ease-in-out, opacity 0.28s ease-in-out; // 对应原来的 280ms
    list-style: none;
    margin: 0;
    padding: 0;
    opacity: 0;
    
    &.show {
      display: block;
      opacity: 1;
    }
    
    li {
      padding: 8px 12px;
      cursor: pointer;
      
      &:hover {
        background-color: #f5f5f5;
      }
      
      span {
        cursor: pointer;
      }
    }
  }
}

.navigation {
  /*float: right;*/
  height: 75px;

  ul.navigationlist {
    &:after {
      content: "";
      display: block;
      height: 0;
      clear: both;
    }

    li {
      float: left;
      display: inline-block;
      position: relative;
      text-align: center;
      width: 110px;
      max-width: 110px;
      //padding: 0 10px;
      &:hover {
        .subnavigationlist {
          display: block;
        }
      }
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        //display: inline-block;
        height: 40px;
        //line-height: 40px;
        margin-top: 16px;
        font-size: 15px;
        font-weight: normal;
        color: #2b2b2b;
        border-radius: 3px;
        transition-duration: .2s;
        -webkit-transition-duration: .2s;
        //white-space: nowrap; /* 防止文字换行 */
        //text-overflow: ellipsis; /* 超出部分显示省略号 */
        //overflow: hidden;

        &:hover {
          text-decoration: none;
          border-bottom: 2px solid #2b2b2b;
          border-radius: 0;
        }
      }
    }

    .current {
      border-bottom: 2px solid #2b2b2b;

      &:hover {
        border-bottom: 2px solid #2b2b2b;
      }
    }
  }

  /* 导航栏下拉菜单 */
  ul.subnavigationlist {
    display: none;
    position: absolute;
    width: 150%;
    left: -25%;
    top: 64px;
    background: #fff;
    z-index: 100;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, .1);

    li {
      float: none;
      padding: 0px;
      display: inline;

      a {
        display: block;
        width: 100%;
        font-weight: normal;
        color: #333;
        line-height: 40px;
        height: 40px;
        font-size: 15px;
        padding: 0;
        border-bottom: 1px solid #eee;
        margin: 0;
        text-align: center;

        &:hover {
          border-bottom: 1px solid #2b2b2b;
        }
      }
    }
  }
}
</style>
